<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import "@/assets/css/mil-pricing.css";
const { itemCount } = defineProps(["itemCount"]);
const steps = ["Decrypting Identifiers", "Calibrating Rates", "Synchronizing Constraints", "Running Model", "Synthesizing Insights"];
const step = ref(0);

let timer;
onMounted(() => {
  timer = setInterval(() => {
    step.value = Math.min(step.value + 1, steps.length - 1);
  }, 600);
});

onUnmounted(() => {
  clearInterval(timer);
});
</script>

<template>
  <div style="width: 100%; flex: 1; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 40px; animation: fadeIn .4s ease">
     <div style="width: 80px; height: 80px; border: 6px solid #f1f5f9; border-top-color: #0067ff; border-radius: 50%; animation: spin 1s linear infinite" />
     <h2 style="font-size: 28px; font-weight: 800; margin-top: 40px; color: #1e293b">Optimizing {{ itemCount }} Assets</h2>
     <p style="color: #64748b; margin-bottom: 40px">Synchronizing data with Blubirch MIL engine...</p>
     <div style="width: 320px; display: flex; flex-direction: column; gap: 14px">
        <div v-for="(s, i) in steps" :key="s" :style="{ display: 'flex', alignItems: 'center', gap: '16px', opacity: i <= step ? 1 : 0.3, transition: 'all 0.3s' }">
          <div :style="{ width: '14px', height: '14px', borderRadius: '50%', background: i < step ? '#00d09c' : i === step ? '#0067ff' : '#e2e8f0' }" />
          <span :style="{ fontSize: '16px', fontWeight: i === step ? 800 : 500, color: i <= step ? '#1e293b' : '#94a3b8' }">{{ s }}</span>
        </div>
     </div>
  </div>
</template>

<style scoped>
@keyframes spin { 
  to { transform: rotate(360deg); } 
}
@keyframes fadeIn { 
  from { opacity: 0; } 
  to { opacity: 1; } 
}
</style>
